export default __webpack_public_path__ + "static/figure-apple-reference-d434205056a0b06f20e96dcfe3873cec.jpg";